import { useState } from 'react'
import type { ScanFinding } from '@/lib/apiTypes'

// ── Finding row (expandable) ──────────────────────────────────────────────────
export function ScanFindingRow({ finding: f }: { finding: ScanFinding }) {
  const [expanded, setExpanded] = useState(false)
  const hasDetail = !!(f.description || f.remediation)

  return (
    <div
      style={{
        background: 'var(--bg3)',
        border: '1px solid var(--border)',
        borderRadius: 6,
        padding: '8px 12px',
        cursor: hasDetail ? 'pointer' : 'default',
      }}
      onClick={() => hasDetail && setExpanded((v) => !v)}
    >
      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        {f.rule_id && (
          <span style={{
            fontFamily: 'var(--mono)', fontSize: '0.68rem',
            background: 'var(--bg)', border: '1px solid var(--border)',
            borderRadius: 3, padding: '1px 5px', color: 'var(--text3)',
            flexShrink: 0,
          }}>
            {f.rule_id}
          </span>
        )}
        <span style={{ fontSize: '0.8rem', color: 'var(--text)', flex: 1 }}>{f.title}</span>
        {hasDetail && (
          <span style={{ fontFamily: 'var(--mono)', fontSize: '0.68rem', color: 'var(--text3)', flexShrink: 0 }}>
            {expanded ? '▲' : '▼'}
          </span>
        )}
      </div>
      {(f.file_path || f.resource) && (
        <div style={{ fontSize: '0.72rem', color: 'var(--text3)', fontFamily: 'var(--mono)', marginTop: 4 }}>
          {f.file_path && <span>{f.file_path}{f.line_start ? `:${f.line_start}` : ''}</span>}
          {f.resource && <span style={{ marginLeft: f.file_path ? 8 : 0 }}>{f.resource}</span>}
        </div>
      )}
      {expanded && (
        <div style={{ marginTop: 8, display: 'grid', gap: 4 }}>
          {f.description && (
            <div style={{ fontSize: '0.78rem', color: 'var(--text2)', lineHeight: 1.5 }}>{f.description}</div>
          )}
          {f.remediation && (
            <div style={{ fontSize: '0.72rem', color: 'var(--accent)', fontFamily: 'var(--mono)' }}>
              → {f.remediation}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
